<app-topnav></app-topnav>
<!-- HEADER -->
<app-header-secondary-h *ngIf="currentLang ==='fr'" [pageTitle]="'Horaires (EDT)'"
    [pageDescription]="['Le logiciel d\'horaire', 'adapté à la réalité scolaire']"
    [imageURL]="'assets/img/logiciels/EDT_top.png'"></app-header-secondary-h>
<app-header-secondary-h *ngIf="currentLang ==='en'" [pageTitle]="'Timetable (EDT)'"
    [pageDescription]="['Timetable software', 'adapted to school reality']"
    [imageURL]="'assets/img/logiciels/EDT_top.png'"></app-header-secondary-h>
<!-- end HEADER -->

<!-- SECTION characteristics -->
<section id="section-characteristics">
    <div id="section-characteristics-inner">
        <div class="container">
            <div class="row">
                <div class="col col-12" *ngIf="currentLang ==='fr'">
                    <h2 class="section-title">
                        <strong>Gérer facilement votre grille horaire !</strong>
                    </h2>
                    <p>Plurilogic travaille depuis 2015 avec Index-Éducation, la firme qui a conçu le logiciel EDT (Emploi du temps). Ce partenariat vous permet de réaliser votre grille horaire facilement tout en vous évitant de faire de la double saisie de données grâce à une interconnexion de réseaux.</p>

                    <h2 class="section-title">
                        <strong>Caractéristiques et avantages</strong>
                    </h2>
                    <ul>
                        <li>La saisie d'horaires se fait dans le logiciel FGP (Fenêtre sur la Gestion Pédagogique) et la
                            prise en charge s'effectue par le logiciel EDT, qui agit comme une véritable passerelle.
                        </li>
                        <li>La réutilisation des données est possible d'une année à l'autre, donc il y a une diminution
                            considérable des tâches.</li>
                        <li>La précision est accrue puisque EDT ne permet pas d'attribuer les mêmes ressources
                            (enseignants, locaux, groupes, élèves) à une même période horaire; le logiciel propose alors
                            d'autres solutions de remplacement.</li>
                        <li>Attestée par nos clients, l'efficience de conception surpasse la saisie manuelle et permet
                            de réduire considérablement le temps de création d'une grille horaire et d'en améliorer la
                            qualité.</li>
                    </ul>

                </div>
                <div class="col col-12" *ngIf="currentLang ==='en'">
                    <h2 class="section-title">
                        <strong>Easily manage your timetable!</strong>
                    </h2>
                    <p>Since 2015, Plurilogic has been working in collaboration with Index-Éducation, the firm who designed the EDT (Emploi du temps) software. This partnership allows you to easily prepare your time grid, and thanks to network interconnections, there is no need to enter the same data twice.</p>

                    <h2 class="section-title">
                        <strong>Benefits and key features</strong>
                    </h2>
                    <ul>
                        <li>Schedule entry into the FGP (Fenêtre sur la pédagogique) is supported by EDT, which is your virtual communication gateway.</li>
                        <li>Possible re-use of the data, year after year, which means significant task reduction.</li>
                        <li>Improved accuracy, since EDT does not let you attribute the same resources (teachers, premises, groups, students) to same time period, and in such case will automatically propose alternative solutions.</li>
                        <li>Efficient design that goes further than manual data entry, as certified by our clients, which enables you to divide by three the time required to prepare a time grid and to improve significantly its quality.</li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- end SECTION characteristics -->

<!-- SECTION informations -->
<section id="section-informations" *ngIf="currentLang ==='fr'">
    <div id="section-informations-inner">
        <div class="container">

            <h3 class="section-title">
                <strong>Téléchargements de EDT pour le Canada (version 2024)</strong>
            </h3>
            <p>Version monoposte :
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-EDTmonoposte2024-ca.php">Installateur</a>
            </p>
            <p>Version réseau :
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-ServeurEDT2024-ca.php">Installateur</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-ClientEDT2024-ca.php">Installateur du client</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-RelaisEDT2024-ca.php">Installateur relais</a>
            </p>
        
           <h3 class="section-title">
                <strong>Téléchargements de EDT pour le Canada (version 2025)</strong>
            </h3>
            <p>Version monoposte :
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-EDTmonoposte2025-ca.php">Installateur</a>
            </p>
            <p>Version réseau :
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-ServeurEDT2025-ca.php">Installateur</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-ClientEDT2025-ca.php">Installateur du client</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-RelaisEDT2025-ca.php">Installateur relais</a>
            </p>
            <p>Documentation :
                <BR><a target="_blank" href="https://www.index-education.com/fr/documentation-edt.php?1">Guides Index-Education</a>
            </p>

            <p>Une fois la version du logiciel EDT installée, vous devrez communiquer avec Renée Varin afin de prendre entente pour l'activation du connecteur EDT. Nous vous ferons ensuite parvenir une soumission avec tous les détails concernant les frais d'utilisation. <b>Les versions d'évaluation sont valables pour deux semaines. Les fonctions d'impression, d'optimisation et de résolution ne sont pas accessibles en version d'évaluation.</b></p>
            <p>Avant de vous lancer dans la conception de vos horaires, nous vous recommandons de consulter les documents et vidéos qui suivent afin de prendre connaissance des démarches préalables à effectuer dans FGP et de pouvoir connaître les manipulations avancées dans EDT qui vous permettront d'économiser du temps.</p>

            <h3 class="section-title">
                <strong>Guide de travail FGP / EDT </strong>
            </h3>

            <p>Ces guides ont été produits par Plurilogic et vous indiquent les procédures à suivre au préalable dans FGP afin de maximiser votre expérience avec EDT. Les guides contiennent également une explication écrite des manipulations de base à utiliser dans EDT.
                <BR><a target="_blank" href="https://www.plurilogic.com/SectionUsagers/Login.srf?Chemin=logiciels_telecharge.srf%3fFichierID=2131%26go=OUI">Guide importation et exportation</a>
                <BR><a target="_blank" href="https://www.plurilogic.com/SectionUsagers/Login.srf?Chemin=logiciels_telecharge.srf%3fFichierID=2134%26go=OUI">Guide d'aménagement de votre horaire</a>
                <BR><a target="_blank" href="https://www.plurilogic.com/SectionUsagers/Login.srf?Chemin=logiciels_telecharge.srf%3fFichierID=2238%26go=OUI">Guide copie prévisionnelle</a>
            </p>


            <h3 class="section-title">
                <strong>Capsules vidéos</strong>
            </h3>

            <p>Vous pouvez <a target="_blank" href="https://www.index-education.com/fr/tutoriels-video-edt.php">cliquer ici</a> pour consulter les capsules réalisées par Index-Education (ces capsules couvrent la plupart des concepts et manipulation du logiciel EDT) :</p>

        </div>
    </div>
</section>
<section id="section-informations" *ngIf="currentLang ==='en'">
    <div id="section-informations-inner">
        <div class="container">

            <h3 class="section-title">
                <strong>Downloading of EDT for Canada  (version 2024)</strong>
            </h3>
            <p>Single-user version :
                <BR><a target="_blank"
                    href="https://www.index-education.com/Telecharger-EDTmonoposte2024-ca.php">Installer</a>
            </p>
            <p>Network version :
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-EDTmonoposte2024-ca.php">Installer</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-ClientEDT2024-ca.php">Installer client</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-RelaisEDT2024-ca.php">Installer relay</a>
            </p>

           <h3 class="section-title">
                <strong>Downloading of EDT for Canada  (version 2025)</strong>
            </h3>
            <p>Single-user version :
                <BR><a target="_blank"
                    href="https://www.index-education.com/Telecharger-EDTmonoposte2025-ca.php">Installer</a>
            </p>
            <p>Network version :
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-EDTmonoposte2025-ca.php">Installer</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-ClientEDT2025-ca.php">Installer client</a>
                <BR><a target="_blank" href="https://www.index-education.com/Telecharger-RelaisEDT2025-ca.php">Installer relay</a>
            </p>
            <p>Documentation :
                <BR><a target="_blank" href="https://www.index-education.com/fr/documentation-edt.php?1">Index-Education Guides</a>
            </p>

            <p>Once the EDT version is installed, you must communicate with Renée Varin, in order to make an arrangement to activate the EDT connector. We will then forward a quotation containing all details about user fees.  <b>Evaluation versions are valid for only two weeks. The printing, optimisation and resolution functions are not available in the evaluation version.</b></p>
            <p>Before starting to design you timetables, we recommend that you attentively read the documents and view the videos described below. You will be able to get all the information you need about the processes to be previously followed in the FGP and to discover the advanced manipulations in EDT which will ultimately save valuable time.</p>

            <h3 class="section-title">
                <strong>Guides FGP / EDT </strong>
            </h3>

            <p>These guides have been produced by Plurilogic to introduce you to the procedures to be previously applied in the FGP, thus maximizing your experience with EDT. These guides also contain written explanations of basic manipulations to be used in EDT.
                <BR><a target="_blank" href="https://www.plurilogic.com/SectionUsagers/Login.srf?Chemin=logiciels_telecharge.srf%3fFichierID=2131%26go=OUI">Guide for import and export</a>
                <BR><a target="_blank" href="https://www.plurilogic.com/SectionUsagers/Login.srf?Chemin=logiciels_telecharge.srf%3fFichierID=2134%26go=OUI">Guide for the creation of your schedule</a>
                <BR><a target="_blank" href="https://www.plurilogic.com/SectionUsagers/Login.srf?Chemin=logiciels_telecharge.srf%3fFichierID=2238%26go=OUI">Guide for annual copy</a>
            </p>


            <h3 class="section-title">
                <strong>Tutorial video</strong>
            </h3>

            <p>You can <a target="_blank" href="https://www.index-education.com/fr/tutoriels-video-edt.php">click here</a> to watch tutorial video that have been prepared by Index-Education (these video clips cover most of the concepts and EDT software manipulation) :</p>

        </div>
    </div>
</section>
<!-- end SECTION informations -->

<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>